import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

// Safely decode JWT
const decodeToken = (token) => {
    try {
        if (!token || typeof token !== 'string') throw new Error("Invalid token format");

        const parts = token.split('.');
        if (parts.length !== 3) throw new Error("Token does not have 3 parts");

        const payload = parts[1];
        const decoded = JSON.parse(
            atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
        );
        return decoded;
    } catch (err) {
        console.error("Invalid token:", err.message);
        return null;
    }
};


const isTokenExpired = (token) => {
    const decoded = decodeToken(token);
    if (!decoded) return true;
    return decoded.exp * 1000 < Date.now();
};

const getRemainingTime = (token) => {
    const decoded = decodeToken(token);
    if (!decoded) return 0;
    const expirationTime = decoded.exp * 1000;
    return Math.max(0, Math.floor((expirationTime - Date.now()) / 1000));
};

const PrivateRoute = ({ children }) => {
    const location = useLocation();
    const token = localStorage.getItem('accessToken');
    const isTokenValid = token && !isTokenExpired(token);

    const [remainingTime, setRemainingTime] = useState(null);

    useEffect(() => {
        if (token) {
            const interval = setInterval(() => {
                const timeLeft = getRemainingTime(token);
                setRemainingTime(timeLeft);

                if (timeLeft <= 0) {
                    clearInterval(interval);
                    localStorage.removeItem('accessToken');
                    localStorage.removeItem('refreshToken');
                    window.location.reload();
                }
            }, 1000);

            return () => clearInterval(interval);
        }
    }, [token]);

    useEffect(() => {
        if (token && isTokenExpired(token)) {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            window.location.reload();
        }
    }, [token]);

    if (isTokenValid) {
        return (
            <>
                {remainingTime !== null && (
                    <div className="countdown-message bg-yellow-500 text-black p-2 rounded-md mb-4">
                        You will be logged out in {Math.floor(remainingTime / 60)} minutes and {remainingTime % 60} seconds!
                    </div>
                )}
                {children}
            </>
        );
    } else {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
};

export default PrivateRoute;
